import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import LogoutButton from './LogoutButton';

loadDOMComponent({
	selector: 'react-logout-button',
	callback: ({ container, context }: any) => {
		const postLogoutUrl = container.getAttribute('postLogoutUrl');
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<LogoutButton postLogoutUrl={postLogoutUrl} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
